import { Button, Badge } from "antd";
import React from "react";
import intl from 'react-intl-universal';
import { useNavigate } from "react-router";
import News from "./component/news";
import PlanHighlight from "./component/planHighlight";
import Products from './component/products'
import Plans from "./component/plans";
import Tutorials from "./component/tutorials";

import { useStore } from "../../hooks/useStore";
import { STORE_USER } from "../../stores/createStores";

import './index.less';

const Home = () => {
    const navigate = useNavigate();
    const user = useStore(STORE_USER);

    const gotoOverview = async () => {
        await user.userInfo();
        navigate('/products#overview');
    }

    return (
        <div className='home'>
            <div className='banner'>
                <div className='container'>
                    <div className='title'>{intl.getHTML('home.banner.title')}</div>
                    <div className='sub-title'>{intl.get('home.banner.subTitle')}</div>
                    <Button className='button' onClick={gotoOverview}>
                        {user && user.level ? intl.get('layout.menu.product') : intl.get('home.banner.button') }
                    </Button>
                </div>
            </div>

            <div className='container content'>
                <PlanHighlight />
                <Badge.Ribbon className="badge-baselevel" placement='start' text="New!" color='red'></Badge.Ribbon>

                <News />

                <div className='products-block' id='products'>
                    <div className='title'>{intl.get('home.products.title')}</div>
                    <Products />
                </div>

                <div className='tutorials-block' id='tutorials'>
                    <div className='title'>{intl.get('home.tutorials.title')}</div>
                    <Tutorials />
                </div>

            </div>

            <div className='sets-block' id='plans'>
                <div className='title'>{intl.get('home.sets.title')}</div>
                <Plans />
            </div>
        </div>
    )
}

export default Home
